import {
  getEvaluationTier,
  type EvaluationTrophyType,
  type EvaluationTierInfo,
} from '../config/scoringConfig.ts';

/**
 * Pure function to calculate performance-based trophy tier and evaluation label from quiz accuracy percentage.
 *
 * By session accuracy (minimum 3 questions):
 * - 100%: Perfect (gold trophy)
 * - 80-99%: Excellent (gold)
 * - 60-79%: Good (silver)
 * - 40-59%: Keep Going (bronze)
 * - Under 40%: Try Again (no trophy)
 * Sessions under 3 questions earn XP but are not ranked or tiered.
 */
export type TrophyTier = EvaluationTrophyType;

export function getTrophyTier(accuracy: number, totalQuestions = 10): TrophyTier {
  const validAccuracy = Number.isFinite(accuracy) ? accuracy : 0;
  return getEvaluationTier({
    accuracyPercent: validAccuracy,
    totalQuestions,
  }).trophy;
}

export function getSessionEvaluation(
  accuracy: number,
  totalQuestions = 10
): EvaluationTierInfo {
  const validAccuracy = Number.isFinite(accuracy) ? accuracy : 0;
  return getEvaluationTier({
    accuracyPercent: validAccuracy,
    totalQuestions,
  });
}

